import { CategoryTypeEnum, UiCategory } from '../types';

export function isSpecialLink(item: UiCategory) {
    const specialTypes = [
        CategoryTypeEnum.SPECIAL_OFFERS,
        CategoryTypeEnum.NEW_PRODUCTS,
        CategoryTypeEnum.TRIAL_OFFERS,
        CategoryTypeEnum.OUTLET,
    ];
    return item.type ? specialTypes.includes(item.type) : false;
}

export function convertTrackingIdTitle(title: string): string {
    return title
        .split(' ')
        .map((substr) => substr.replace(' ', '-'))
        .join('-');
}

export function getTrackingId({
    type,
    level,
    title,
    index,
    parentTitle,
}: {
    title: string;
    type?: CategoryTypeEnum;
    level: number;
    index?: number;
    parentTitle?: string;
}): string {
    const prefix = 'header-category-flyout-animal';
    if (type === CategoryTypeEnum.SPECIAL_OFFERS) {
        return `${prefix}-special-offer-links-${convertTrackingIdTitle(title)}`;
    }
    if (index !== undefined && parentTitle !== undefined) {
        return `${prefix}-level4-links-${convertTrackingIdTitle(parentTitle)}-${index}-${convertTrackingIdTitle(title)}`;
    }
    return `${prefix}-level${level}-links-${convertTrackingIdTitle(title)}`;
}
